import {HyperDropComponent} from "./HyperDropComponent";

export class HyperDropDropdown extends HyperDropComponent {

  isOpen: boolean = false;
  openClass: string = 'open';
  isLocked: boolean = false;
  openOnMouseOver: boolean = false;

  onMount(options): void {
    this.openOnMouseOver = options.openOnMouseOver || false;
    this.elements.toggle = this.elements.root.querySelector('.toggle');
    this.elements.panel = this.elements.root.querySelector('.dropdown-panel');
    this.elements.totalSelected = this.elements.root.querySelector('.total-selected');
    this.elements.toggle.addEventListener('click', () => this.toggle());

    if (this.openOnMouseOver) {
      this.elements.toggle.addEventListener('mouseenter', (e: KeyboardEvent) => {
        if (!this.isOpen) {
          this.open();
        }
      });

      this.elements.root.addEventListener('mouseleave', (e: KeyboardEvent) => {
        if (this.isOpen && !this.isLocked) {
          this.close();
        }
      });
    }


    this.elements.checkboxes.forEach((checkbox: HTMLInputElement) => {
      const selectedCount = this.getAmountSelected();
      this.setSelectedCount(selectedCount);
      checkbox.addEventListener('change', () => {
        const selectedCount = this.getAmountSelected();
        this.setSelectedCount(selectedCount);
      });
    });
  }

  getAmountSelected(): number {
    return Array.from(this.elements.checkboxes).filter(
      (cb: HTMLInputElement) => cb.checked
    ).length;
  }

  setSelectedCount(count: number) {
    if(!this.elements.totalSelected) return
    this.elements.totalSelected.innerHTML = count ? count.toString() : '';
    if (count <= 0) {
      this.elements.totalSelected.classList.add('d-none');
      this.elements.totalSelected.classList.remove('d-flex'); //TODO dont enforce flex here. design should be decided by the template that uses this.
    } else {
      this.elements.totalSelected.classList.remove('d-none');
      this.elements.totalSelected.classList.add('d-flex');
    }
  }

  toggle() {
    if (this.isOpen && this.isLocked) {
      this.close();
      this.unlock()
    } else {
      this.open();
      this.lock()
    }
  }

  lock() {
    this.isLocked = true;
    this.elements.root.classList.add('is-locked');
  }

  unlock() {
    this.isLocked = false;
    this.elements.root.classList.remove('is-locked');
  }

  open() {
    this.elements.root.classList.add(this.openClass);
    this.elements.panel.classList.add(this.openClass)
    this.isOpen = true;

    this.emit(this.elements.root, "dropdown:open", {accordion: this});
  }

  close() {
    this.elements.root.classList.remove(this.openClass);
    this.isOpen = false;
    this.elements.panel.classList.remove(this.openClass)
    this.emit(this.elements.root, "dropdown:close", {accordion: this});
  }
}
